// extracted by mini-css-extract-plugin
module.exports = {"message":"src-lib-app-components-SuccessNotification-style-module__message--3nBvZ","infoIcon":"src-lib-app-components-SuccessNotification-style-module__infoIcon--2n6Le"};